// The "staff" login is floor staff: operations only. Finance, wages / pay rates, forecasts and the
// owner-level Settings stay with managers (the API refuses them too -- see backend/auth.py).
export const isFloorStaff = (user) => user?.role === "staff";
